import Layout from "components/Layout";
import { ReactElement } from "react";
import { PrivacyPage } from "shared-pages";

const Privacy = () => <PrivacyPage />;

Privacy.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export default Privacy;
